import { useContext } from 'react';
import Link from 'next/link';
import { CheckIcon } from '@heroicons/react/24/outline';
import { FinancialStatusContext } from '../../context/financial-status-context';
import Download from '../../../../_sharedComponents/download-wrapper';

export default function FinalStep() {
	const financialContext = useContext(FinancialStatusContext);

	return (
		<div className="flex h-full flex-col gap-2">
			<div className="flex items-center gap-2 text-2xl">
				{financialContext.language === 'en' ? 'Success' : 'Éxito'}
				<div className="flex h-5 w-5 items-center justify-center rounded-full bg-green-500">
					<CheckIcon className="h-4 w-4 text-white" />
				</div>
			</div>
			<div className="w-full text-lg md:w-[50%]">
				{financialContext.language === 'en'
					? 'The form has been successfully submited. You may download this file for your own records.'
					: 'El formulario se ha enviado correctamente. Puede descargar este archivo para sus propios registros.'}
			</div>
			<Download filename="financial-status-form.pdf" href={financialContext.pdfHref}>
				<button
					className="text border-uc-blue text-uc-blue my-2 flex w-52 justify-center gap-2 text-nowrap rounded-md border-[3.75px] px-4 py-2"
					disabled={financialContext.pdfHref === undefined}
					type="button"
				>
					<b>{financialContext.language === 'en' ? 'Download Copy' : 'Descargar una copia'}</b>{' '}
					<svg
						className="size-6"
						fill="none"
						stroke="currentColor"
						strokeWidth={1.5}
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</button>
			</Download>
			<div className="text-UC-blue-700 mt-5 space-y-3 underline">
				<div>
					<Link href="/court-hearings">
						{financialContext.language === 'en'
							? 'More information on Court Hearings'
							: 'Más información sobre Audiencias Judiciales'}
					</Link>
				</div>
				<div>
					<Link href="/">{financialContext.language === 'en' ? 'Go to the homepage' : 'Ir a la página de inicio'}</Link>
				</div>
			</div>
		</div>
	);
}
